import React, { useRef } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Ic } from './Icons.jsx';

function Frame({ title, description, onClose, busy, children }) {
  const returnFocus = useRef(document.activeElement);
  const content = useRef(null);
  return <Dialog.Root open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <Dialog.Portal container={document.querySelector('.original-demo') || undefined}><Dialog.Overlay className="workspace-overlay" />
      <Dialog.Content ref={content} className="workspace-dialog" {...(description ? {} : { 'aria-describedby': undefined })}
        onEscapeKeyDown={event => { if (busy) event.preventDefault(); }}
        onOpenAutoFocus={event => { const input = content.current?.querySelector('textarea'); if (input) { event.preventDefault(); input.focus(); } }}
        onPointerDownOutside={event => event.preventDefault()}
        onCloseAutoFocus={event => {
          event.preventDefault();
          const previous = returnFocus.current;
          const target = previous?.isConnected && previous !== document.body && previous.getClientRects().length
            && getComputedStyle(previous).visibility === 'visible' && !previous.closest('[inert]')
            ? previous : document.querySelector('#workspace-menu-toggle') || document.querySelector('.nav-item');
          target?.focus();
        }}>
        <div className="workspace-dialog-head"><Dialog.Title>{title}</Dialog.Title>
          <button className="icon-btn" disabled={busy} onClick={onClose} aria-label={title.startsWith('新') || title.startsWith('删') ? '关闭' : 'Close'}><Ic.Close /></button></div>
        {description && <Dialog.Description>{description}</Dialog.Description>}
        {children}
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>;
}

export function NewTherapyDialog({ locale, onSubmit, onClose, busy, error, locked }) {
  const tr = (zh, en) => locale.startsWith('zh') ? zh : en;
  return <Frame title={tr('新建咨询', 'New Therapy')} busy={busy} onClose={onClose}>
    <form onSubmit={event => { event.preventDefault(); if (!busy) onSubmit(); }}>
      {error && <p id="new-therapy-error" role="alert">{error}</p>}
      <div className="workspace-dialog-actions"><button type="button" className="workspace-secondary" disabled={busy} onClick={onClose}>{tr('取消', 'Cancel')}</button>
        <button className="workspace-primary" disabled={busy}>{busy ? tr('正在创建…', 'Creating…') : locked ? tr('重试创建', 'Retry creation') : tr('开始咨询', 'Start consultation')}</button></div>
    </form>
  </Frame>;
}

export function DeleteChatDialog({ locale, title, busy, error, onClose, onConfirm }) {
  const tr = (zh, en) => locale.startsWith('zh') ? zh : en;
  return <Frame title={tr('删除聊天记录', 'Delete chat')} busy={busy} onClose={onClose}
    description={tr(`将永久删除“${title}”及其中的消息，无法撤销。咨询分组和记忆不会因此删除。`, `Permanently delete “${title}” and its messages? This cannot be undone. Therapy groups and memories are separate.`)}>
    {error && <p role="alert">{error}</p>}
    <div className="workspace-dialog-actions"><button className="workspace-secondary" disabled={busy} onClick={onClose}>{tr('取消', 'Cancel')}</button>
      <button className="workspace-danger" disabled={busy} onClick={onConfirm}>{busy ? tr('正在删除…', 'Deleting…') : tr('删除', 'Delete')}</button></div>
  </Frame>;
}


export function DeleteTherapyDialog({ locale, title, busy, error, onClose, onConfirm }) {
  const tr = (zh, en) => locale.startsWith('zh') ? zh : en;
  return <Frame title={tr('删除咨询分组', 'Delete therapy group')} busy={busy} onClose={onClose}
    description={tr(`将永久删除“${title}”及其咨询记录和相关记忆，无法撤销。`, `Permanently delete “${title}”, its sessions and associated memories? This cannot be undone.`)}>
    {error && <p role="alert">{error}</p>}
    <div className="workspace-dialog-actions"><button className="workspace-secondary" disabled={busy} onClick={onClose}>{tr('取消', 'Cancel')}</button>
      <button className="workspace-danger" disabled={busy} onClick={onConfirm}>{busy ? tr('正在删除…', 'Deleting…') : tr('删除', 'Delete')}</button></div>
  </Frame>;
}

export function DeleteCurrentSessionDialog({ locale, sessionIndex, busy, error, onClose, onConfirm }) {
  const tr = (zh, en) => locale.startsWith('zh') ? zh : en;
  return <Frame title={tr('删除本次咨询', 'Delete current session')} busy={busy} onClose={onClose}
    description={tr(`删除第${sessionIndex}次未完成咨询及其中的对话？分组和已归档记录会保留，之后可以重新开始这一次咨询。此操作无法撤销。`,
      `Delete unfinished session ${sessionIndex} and its conversation? The group and archived sessions will remain, and you can restart this session. This cannot be undone.`)}>
    {error && <p role="alert">{error}</p>}
    <div className="workspace-dialog-actions"><button className="workspace-secondary" disabled={busy} onClick={onClose}>{tr('取消', 'Cancel')}</button>
      <button className="workspace-danger" disabled={busy} onClick={onConfirm}>{busy ? tr('正在删除…', 'Deleting…') : tr('删除', 'Delete')}</button></div>
  </Frame>;
}
